/* @@DISPNO_START@@ — extracted by qa/merge_props.js alongside the rev engine.
   ⚠⚠ v16.9 (W4): THE SENTINELS EXIST BECAUSE THE DEPENDENCY IS NEW AND REAL.
   `_revCaptureBaseline` now asks `_dispNoOf` what number a record holds, so the rev engine no
   longer stands alone — merge_props.js evals it OUTSIDE the browser and broke with
   "_dispNoOf is not defined" the moment W4 landed. ✅ The rig extracts this block rather than
   keeping its own copy of "what counts as a valid display number": a second copy is free to
   drift from the one the app actually uses, which is the whole reason nothing in this harness
   is ever transplanted. */
function _dispNoOf(r) {
  return (r && typeof r.displayNo === 'number' && isFinite(r.displayNo) && r.displayNo > 0)
    ? r.displayNo : 0;
}
function _dispNoNext(list) {
  let hi = 0;
  list.forEach(r => { const n = _dispNoOf(r); if (n > hi) hi = n; });
  return hi + 1;
}
/* @@DISPNO_END@@ */
